export default __webpack_public_path__ + "static/the_office_of_government_property-d1dd1465f0f052e3c7865ff1ce335fa6.png";